import React, { useMemo } from 'react';

export interface CpProgressBarProps {
  /**
   * A number between 0 - 100
   */
  progress: number;
  bgColor?: string;
  progressColor?: string;
  hideProgress?: boolean;
}

export const CpProgressBar: React.FC<CpProgressBarProps> = ({
  progress,
  bgColor,
  progressColor,
  hideProgress,
}) => {
  const calculatedProgress = useMemo(() => {
    return Math.floor(progress ?? 0);
  }, [progress]);

  return (
    <div
      className="cp-w-[100px] cp-bg-[var(--cp-cyan-30)] cp-rounded-full cp-h-2 cp-overflow-hidden"
      style={{ background: bgColor }}
    >
      <div
        className="cp-bg-[var(--cp-cyan-20)] cp-h-2 cp-rounded-full cp-flex cp-items-center cp-justify-start cp-min-w-[4px]"
        style={{
          width: `${calculatedProgress}%`,
          background: progressColor,
        }}
      >
        {!hideProgress && `${calculatedProgress}%`}
      </div>
    </div>
  );
};
